function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

const SvgTrafficLight = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0.3 80 259.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 47.7,
    cy: 47.3,
    r: 47.8,
    transform: "matrix(0.837704 0 0 0.832294 0.041385 0.622022)",
    style: {
      fill: "rgb(220, 43, 31)",
      paintOrder: "fill"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 99.1,
    r: 47.8,
    transform: "matrix(0.837704 0 0 0.832294 29.495239 47.558235)",
    style: {
      fill: "rgb(251, 176, 64)",
      paintOrder: "fill"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -117.9,
    cy: 202.9,
    r: 47.8,
    transform: "matrix(0.837704 0 0 0.832294 138.760239 51.094028)",
    style: {
      fill: "rgb(57, 181, 74)",
      paintOrder: "fill"
    }
  }));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTrafficLight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/TrafficLight.b3e6bc0a.svg";
export { ForwardRef as ReactComponent };